import React, {useState} from 'react';
import * as S from './NoResults.styles';

const NoResultsCard = (props) => {
  return (
    <S.NoResultsCard>
      <img
        src="https://gos3.ibcdn.com/busnoresultimg-1591617244.png"
        width="110px"
        height="110px"
      />
      <S.ErrorMsg>{props.message}</S.ErrorMsg>
      {props.subText ? <S.SmallText>{props.subText}</S.SmallText> :null}
      {props.cb ? <S.ResetButton onClick={props.cb}>RESET FILTERS</S.ResetButton> :null}
    </S.NoResultsCard>
  );
};

export default NoResultsCard;
